/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: w2GXN278dkQ2gQTVQnPehW
// Component: _qAXa8aqLB77

import * as React from "react";

import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  Flex as Flex__,
  renderPlasmicSlot,
  StrictProps,
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";

import IconButton from "../../components/widgets/IconButton"; // plasmic-import: LPry-TF4j22a/component
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: w2GXN278dkQ2gQTVQnPehW/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import projectcss from "./plasmic_plasmic_kit_data_binding.module.css"; // plasmic-import: w2GXN278dkQ2gQTVQnPehW/projectcss
import sty from "./PlasmicPopoverFrameTitle.module.css"; // plasmic-import: _qAXa8aqLB77/css

import ArrowLeftSvgIcon from "../plasmic_kit_icons/icons/PlasmicIcon__ArrowLeftSvg"; // plasmic-import: -d8Kjj4sp/icon
import CloseSvgIcon from "../plasmic_kit_icons/icons/PlasmicIcon__CloseSvg"; // plasmic-import: DhvEHyCHT/icon

createPlasmicElementProxy;

export type PlasmicPopoverFrameTitle__VariantMembers = {};
export type PlasmicPopoverFrameTitle__VariantsArgs = {};
type VariantPropType = keyof PlasmicPopoverFrameTitle__VariantsArgs;
export const PlasmicPopoverFrameTitle__VariantProps =
  new Array<VariantPropType>();

export type PlasmicPopoverFrameTitle__ArgsType = {
  showBack?: boolean;
  title?: React.ReactNode;
};
type ArgPropType = keyof PlasmicPopoverFrameTitle__ArgsType;
export const PlasmicPopoverFrameTitle__ArgProps = new Array<ArgPropType>(
  "showBack",
  "title"
);

export type PlasmicPopoverFrameTitle__OverridesType = {
  popoverFrameTitle?: Flex__<"div">;
  back?: Flex__<typeof IconButton>;
  titleWrap?: Flex__<"div">;
  close?: Flex__<typeof IconButton>;
};

export interface DefaultPopoverFrameTitleProps {
  showBack?: boolean;
  title?: React.ReactNode;
  className?: string;
}

const $$ = {};

function PlasmicPopoverFrameTitle__RenderFunc(props: {
  variants: PlasmicPopoverFrameTitle__VariantsArgs;
  args: PlasmicPopoverFrameTitle__ArgsType;
  overrides: PlasmicPopoverFrameTitle__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {
          showBack: false,
        },
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants,
  };

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const styleTokensClassNames = _useStyleTokens();

  return (
    <div
      data-plasmic-name={"popoverFrameTitle"}
      data-plasmic-override={overrides.popoverFrameTitle}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        styleTokensClassNames,
        sty.popoverFrameTitle
      )}
    >
      {(() => {
        try {
          return $props.showBack;
        } catch (e) {
          if (
            e instanceof TypeError ||
            e?.plasmicType === "PlasmicUndefinedDataError"
          ) {
            return false;
          }
          throw e;
        }
      })() ? (
        <IconButton
          data-plasmic-name={"back"}
          data-plasmic-override={overrides.back}
          className={classNames("__wab_instance", sty.back)}
        >
          <ArrowLeftSvgIcon
            className={classNames(projectcss.all, sty.svg__kv0Et)}
            role={"img"}
          />
        </IconButton>
      ) : null}
      <div
        data-plasmic-name={"titleWrap"}
        data-plasmic-override={overrides.titleWrap}
        className={classNames(projectcss.all, sty.titleWrap)}
      >
        {renderPlasmicSlot({
          defaultContents: "Edit Object",
          value: args.title,
          className: classNames(sty.slotTargetTitle),
        })}
      </div>
      <IconButton
        data-plasmic-name={"close"}
        data-plasmic-override={overrides.close}
        className={classNames("__wab_instance", sty.close)}
      >
        <CloseSvgIcon
          className={classNames(projectcss.all, sty.svg___8TSbt)}
          role={"img"}
        />
      </IconButton>
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  popoverFrameTitle: ["popoverFrameTitle", "back", "titleWrap", "close"],
  back: ["back"],
  titleWrap: ["titleWrap"],
  close: ["close"],
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  popoverFrameTitle: "div";
  back: typeof IconButton;
  titleWrap: "div";
  close: typeof IconButton;
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicPopoverFrameTitle__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicPopoverFrameTitle__VariantsArgs;
    args?: PlasmicPopoverFrameTitle__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & // Specify variants directly as props
  Omit<PlasmicPopoverFrameTitle__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicPopoverFrameTitle__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicPopoverFrameTitle__ArgProps,
          internalVariantPropNames: PlasmicPopoverFrameTitle__VariantProps,
        }),
      [props, nodeName]
    );
    return PlasmicPopoverFrameTitle__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName,
    });
  };
  if (nodeName === "popoverFrameTitle") {
    func.displayName = "PlasmicPopoverFrameTitle";
  } else {
    func.displayName = `PlasmicPopoverFrameTitle.${nodeName}`;
  }
  return func;
}

export const PlasmicPopoverFrameTitle = Object.assign(
  // Top-level PlasmicPopoverFrameTitle renders the root element
  makeNodeComponent("popoverFrameTitle"),
  {
    // Helper components rendering sub-elements
    back: makeNodeComponent("back"),
    titleWrap: makeNodeComponent("titleWrap"),
    close: makeNodeComponent("close"),

    // Metadata about props expected for PlasmicPopoverFrameTitle
    internalVariantProps: PlasmicPopoverFrameTitle__VariantProps,
    internalArgProps: PlasmicPopoverFrameTitle__ArgProps,
  }
);

export default PlasmicPopoverFrameTitle;
/* prettier-ignore-end */
